// Styles de carte
var styles = [];

// Addition to remove equator / dateline
// Base on this : http://stackoverflow.com/a/6076271
styles.push({
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
        { visibility: "off" }
    ]
});

// Return the styles
module.exports = styles;


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-region-map/RegionMapStyle.js